import { Fragment } from "react";
import NetworkIcon from "../../../icons/networkIcon";
import TermCard from "./termCard";
import { useTranslation } from "react-i18next";

const InternationalTrade = () => {
  const { t } = useTranslation();
  const terms = [
    {
      img: "/assets/EXW.png",
      name: "exWorks",
      cost: "exWorksCost",
      risks: "exWorksRisk",
    },
    {
      img: "/assets/FOB.png",
      name: "FOB",
      cost: "FOBCost",
      risks: "FOBRisk",
    },
    {
      img: "/assets/CIF.png",
      name: "CIF",
      cost: "CIFCost",
      risks: "CIFRisk",
      insurance: true,
    },
    {
      img: "/assets/FCA.png",
      name: "FCA",
      cost: "FCACost",
      risks: "FCARisk",
    },
    {
      img: "/assets/CPT.png",
      name: "CPT",
      cost: "CPTCost",
      risks: "CPTRisk",
    },
    {
      img: "/assets/CIP.png",
      name: "CIP",
      cost: "CIPCost",
      risks: "CIPRisk",
      insurance: true,
    },
    {
      img: "/assets/DAP.png",
      name: "DAP",
      cost: "DAPCost",
      risks: "DAPRisk",
      insurance: true,
    },
    {
      img: "/assets/DPU.png",
      name: "DPU",
      cost: "DPUCost",
      risks: "DPURisk",
      insurance: true,
    },
    {
      img: "/assets/DDP.png",
      name: "DDP",
      cost: "DDPCost",
      risks: "DDPRisk",
      insurance: true,
    },
    {
      img: "/assets/FAS.png",
      name: "FAS",
      cost: "FASCost",
      risks: "FASRisk",
      insurance: true,
    },
    {
      img: "/assets/CFR.png",
      name: "CFR",
      cost: "CFRCost",
      risks: "CFRRisk",
      insurance: true,
    },
  ];

  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <span className="block mx-auto w-fit">
            <NetworkIcon fill="#0051FF" className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("incoterms")}
          </h1>

          <section>
            {terms.map((term, i) => (
              <Fragment key={i}>
                <TermCard term={term} />
              </Fragment>
            ))}
          </section>
        </div>
      </article>
    </main>
  );
};

export default InternationalTrade;
